import * as React from 'react';

const SquareUp24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M16.6 9H17.8C18.1183 9 18.4235 9.12643 18.6485 9.35147C18.8736 9.57652 19 9.88174 19 10.2V19.8C19 20.1183 18.8736 20.4235 18.6485 20.6485C18.4235 20.8736 18.1183 21 17.8 21H6.2C5.88174 21 5.57652 20.8736 5.35147 20.6485C5.12643 20.4235 5 20.1183 5 19.8V10.2C5 9.88174 5.12643 9.57652 5.35147 9.35147C5.57652 9.12643 5.88174 9 6.2 9H7.4M12 3V13M12 3L8.99999 6M12 3L15 6'
				stroke='black'
				stroke-width='1.5'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

export default SquareUp24;
